import axios from 'axios';
import { winnreNoAuth } from "../utils/axios";

  const headers2 = {
    "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    Authorization: `Bearer ${sessionStorage.getItem("refreshToken")}`,
    "Client-Id": `43f9ae0bd0e04f52e4d95b93bcf34138dbf6052b78dc2710ff4eb90b3c69f096}`,
  };
const refreshToken = () => {
     return new Promise((resolve, reject) => {
        winnreNoAuth
      .get(
        `/winnre/login/refreshToken`,
       {
          headers: headers2,
        }
      )
      .then((res) => {
        if(res.accessToken)
            {
                sessionStorage.setItem("accessToken",res.accessToken);
                sessionStorage.setItem("refreshToken",res.refreshToken);
                 resolve(res.accessToken);
            }else {
                    reject('No access token in response');
                }
      })})
};

export { refreshToken };